// import HomePageSlider from "../../assets/images/home-images/slider1.gif"
import SportsImg from "../../assets/images/home-images/sportbook.webp";
import BetradarImg from "../../assets/images/home-images/banner_virtualsports.png";
import BlogsImg from "../../assets/images/home-images/blogs-image.png";
import BannerSports from "../../assets/images/home-images/sports-banner.webp";
import HorseRacingImage from "../../assets/images/home-images/horse-racing.webp";
import GreyhoundRacingImage from "../../assets/images/home-images/greyhound-racing.webp";
import {
  CASINO_ROUTE,
  CRICKET_ROUTE,
  EXCHANGE_SPORTS_ROUTE,
  FOOTBALL_ROUTE,
  IN_PLAY_ROUTE,
  POPULAR_EVENTS_ROUTE,
  SPORTS_BOOK_ROUTE,
} from "@hypexone/uicore";
import Mac88Virtual from "../../assets/images/providers/mac-virtuals.svg";
import Evolution from "../../assets/images/providers/evolution.svg";
import Smartsoft from "../../assets/images/providers/smartsoft.svg";
import Jili from "../../assets/images/providers/jili.svg";
import Betsoft from "../../assets/images/providers/betsoft.svg";
import BetGames from "../../assets/images/providers/betgames.svg";
import RG from "../../assets/images/providers/royalgaming.svg";
import FunGames from "../../assets/images/providers/FunGames.svg";
import Spribe from "../../assets/images/providers/spribe.svg";
import Turbo from "../../assets/images/providers/TurboGames.svg";
import AeSexy from "../../assets/images/providers/Aesexy.svg";
import Ezugi from "../../assets/images/providers/ezugi.svg";
import Mac88 from "../../assets/images/providers/mac88.svg";
import Gamzix from "../../assets/images/providers/gamzix.svg";
import MacExcite from "../../assets/images/providers/mac-excite.svg";

export const gamesImagesData: {
  title: string;
  imageSrc: string;
  alt: string;
  url?: string;
  customClassName?: string;
  isWhatsapp?: boolean;
}[] = [
  // Temporarily hidden — uncomment to restore Mac88 banner (desktop + mobile)
  // {
  //   title: 'Mac88',
  //   imageSrc: "https://prod-cdn.king18.co/mac88.gif",
  //   alt: "mac88",
  //   url: `/casino?subProvider=MAC88&category=ALL`,
  //   customClassName: "col-span-4 md:col-span-3 md:h-auto",
  // },
  {
    title: 'Sports',
    imageSrc: BannerSports,
    alt: "live-events",
    url: `${IN_PLAY_ROUTE}`,
    customClassName: "col-span-4 md:col-span-3 md:h-auto",
  },
  {
    title: ' ',
    imageSrc: BlogsImg,
    isWhatsapp: true,
    alt: "Blogs",
    customClassName: "col-span-4 md:col-span-3 md:h-auto",
  },
  {
    title: 'Sports Book',
    imageSrc: BetradarImg,
    url: SPORTS_BOOK_ROUTE,
    alt: "sportsbook",
    customClassName: "col-span-4 md:col-span-3 md:h-auto",
  },
];

export const HorseRacingImagesData: {
  imageSrc: string;
  alt: string;
  url?: string;
  customClassName?: string;
}[] = [
  {
    imageSrc: HorseRacingImage,
    url: "/exchange_sports/horserace",
    alt: "horse-racing",
    customClassName: "col-span-2 md:col-span-3 h-[102px] md:h-[333px]",
  },
  {
    imageSrc: GreyhoundRacingImage,
    url: "/exchange_sports/greyhound",
    alt: "greyhound-racing",
    customClassName: "col-span-2 md:col-span-3 h-[102px] md:h-[333px]",
  },
];

/** Same order/set as one8 CasinoProviderTiles */
export const HomeProvidersIcons = [
  { icon: Mac88Virtual, subProviderName: "MAC88 VIRTUALS" },
  { icon: Evolution, subProviderName: "EVOLUTION" },
  { icon: Smartsoft, subProviderName: "SMARTSOFT" },
  { icon: Jili, subProviderName: "JILI" },
  { icon: Betsoft, subProviderName: "BETSOFT" },
  { icon: BetGames, subProviderName: "BetGames_TV" },
  { icon: RG, subProviderName: "ROYAL GAMING" },
  { icon: FunGames, subProviderName: "FUN GAMES" },
  { icon: Spribe, subProviderName: "SPRIBE" },
  { icon: Turbo, subProviderName: "TURBO" },
  { icon: AeSexy, subProviderName: "AE SEXY" },
  { icon: Ezugi, subProviderName: "EZUGI" },
  { icon: Mac88, subProviderName: "MAC88" },
  { icon: Gamzix, subProviderName: "GAMZIX" },
  { icon: MacExcite, subProviderName: "MAC EXCITE" },
];

export const HomeMobProvidersIcons = HomeProvidersIcons;
